export const getEnvVar = (key: string): string => {
  
  // In development, use Vite's import.meta.env
  if (import.meta.env.DEV) {
    const value = (import.meta.env as any)[key];
    return value || '';
  }
  
  // In production, use WordPress-injected variables
  if (typeof window !== 'undefined' && window.talentfulCalculatorEnv) {
    const value = window.talentfulCalculatorEnv[key as keyof typeof window.talentfulCalculatorEnv];
    return value || '';
  }
  
  return '';
};
